/* Magic Pillow storefront JS (draft CRO build) */
(function () {
  'use strict';
  var C = window.MP_CONFIG || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || C.currency || 'USD';
    var whole = Math.round(v) === v;
    try { return new Intl.NumberFormat(cur === 'GBP' ? 'en-GB' : 'en-US', { style: 'currency', currency: cur, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return '$' + (whole ? v : v.toFixed(2)); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200); }
  function toast(msg) {
    var t = $('#mp-toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2600);
  }

  /* ---------- overlays & drawers ---------- */
  var overlay = $('#mp-overlay');
  var openDrawerEl = null;
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    if (openDrawerEl && openDrawerEl !== d) closeDrawer(true);
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-open');
    document.body.classList.add('mp-lock');
    openDrawerEl = d;
    var f = d.querySelector('[data-autofocus]') || d.querySelector('button, a, input');
    setTimeout(function () { try { f && f.focus({ preventScroll: true }); } catch (e) { } }, 80);
  }
  function closeDrawer(keepOverlay) {
    if (!openDrawerEl) return;
    openDrawerEl.classList.remove('is-open'); openDrawerEl.setAttribute('aria-hidden', 'true');
    openDrawerEl = null;
    if (!keepOverlay) { overlay && overlay.classList.remove('is-open'); document.body.classList.remove('mp-lock'); }
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-mp-open]');
    if (o) { e.preventDefault(); var id = o.getAttribute('data-mp-open'); if (id === 'mp-cart') { Cart.refresh().then(function () { openDrawer(id); }, function () { openDrawer(id); }); } else openDrawer(id); if (o.hasAttribute('data-mp-tab')) sgTab(o.getAttribute('data-mp-tab')); return; }
    if (e.target.closest('[data-mp-close]') || e.target === overlay) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- cart ---------- */
  var Cart = {
    data: null,
    get: function () { return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); },
    post: function (path, body) {
      return fetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    },
    refresh: function () { return Cart.get().then(function (c) { return Gifts.sync(c); }).then(function (c) { Cart.data = c; renderCart(c); return c; }); },
    add: function (items) { return Cart.post('cart/add.js', { items: items }).then(Cart.refresh); },
    change: function (key, qty) { return Cart.post('cart/change.js', { id: key, quantity: qty }).then(function () { return Cart.refresh(); }); }
  };
  window.MPCart = Cart;

  /* ---------- free gift engine ---------- */
  function sizeKey(str) {
    var s = String(str || '').toUpperCase().trim();
    if (/^XXL|2XL/.test(s)) return 'XXL';
    if (/^XL/.test(s)) return 'XL';
    return 'L';
  }
  function bedSizeOfItem(it) {
    var opt = (it.options_with_values || []).filter(function (o) { return /size/i.test(o.name); })[0];
    return sizeKey(opt ? opt.value : (it.variant_options || [])[0]);
  }
  var Gifts = {
    enabled: function () { return C.gifts && C.gifts.length && C.bedProductId; },
    desired: function (cart) {
      var beds = { L: 0, XL: 0, XXL: 0 };
      cart.items.forEach(function (it) { if (String(it.product_id) === String(C.bedProductId)) { beds[bedSizeOfItem(it)] += it.quantity; } });
      if (C.giftsFirstBedOnly) { var first = Object.keys(beds).filter(function (k) { return beds[k] > 0; })[0]; beds = { L: 0, XL: 0, XXL: 0 }; if (first) beds[first] = 1; }
      var want = {};
      C.gifts.forEach(function (g) {
        Object.keys(beds).forEach(function (sz) {
          if (!beds[sz]) return;
          var vid = String(g.variants[sz] || g.variants.L);
          want[vid] = (want[vid] || 0) + g.qty * beds[sz];
        });
      });
      return want;
    },
    sync: function (cart) {
      if (!Gifts.enabled() || Gifts.running) return Promise.resolve(cart);
      var want = Gifts.desired(cart), have = {}, updates = {}, adds = [], changed = false;
      cart.items.forEach(function (it) {
        if (it.properties && it.properties._mp_gift) {
          var vid = String(it.variant_id);
          if (have[vid]) { updates[it.key] = 0; changed = true; return; }
          have[vid] = it;
        }
      });
      Object.keys(have).forEach(function (vid) { var w = want[vid] || 0; if (have[vid].quantity !== w) { updates[have[vid].key] = w; changed = true; } });
      Object.keys(want).forEach(function (vid) { if (!have[vid] && want[vid] > 0) { adds.push({ id: Number(vid), quantity: want[vid], properties: { _mp_gift: 'bed' } }); changed = true; } });
      if (!changed) return Promise.resolve(cart);
      Gifts.running = true;
      var p = Promise.resolve();
      if (Object.keys(updates).length) p = p.then(function () { return Cart.post('cart/update.js', { updates: updates }); });
      if (adds.length) p = p.then(function () { return Cart.post('cart/add.js', { items: adds }); });
      return p.catch(function (e) { console.warn('[MP gifts]', e); }).then(Cart.get).then(function (c) { Gifts.running = false; return c; }, function (e) { Gifts.running = false; throw e; });
    }
  };
  window.MPGifts = Gifts;

  function lineHTML(it, gift) {
    var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(String(o.value).split(' (')[0]); }).join(' · ');
    var discounted = it.final_line_price < it.original_line_price;
    var discs = (it.line_level_discount_allocations || []).map(function (d) { return '<span class="mp-line__disc">' + esc(d.discount_application.title) + '</span>'; }).join(' ');
    var price = gift
      ? '<s>' + money(it.original_line_price) + '</s><span class="mp-free">' + (it.final_line_price === 0 ? 'FREE' : money(it.final_line_price)) + '</span>'
      : (discounted ? '<s>' + money(it.original_line_price) + '</s>' : '') + money(it.final_line_price);
    var controls = gift
      ? '<div class="mp-line__opts">' + (it.quantity > 1 ? it.quantity + ' × ' : '') + (opts ? opts + ' · ' : '') + 'sized to your bed</div>'
      : '<div><span class="mp-qty"><button type="button" data-mp-qty="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-mp-qty="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase">+</button></span><button type="button" class="mp-line__remove" data-mp-qty="' + esc(it.key) + '" data-q="0">Remove</button></div>';
    return '<div class="mp-line' + (gift ? ' mp-line--gift' : '') + '">' +
      '<a href="' + esc(it.url) + '"><img src="' + esc(img(it.image, 180)) + '" alt="" loading="lazy" width="76" height="76"></a>' +
      '<div><a class="mp-line__title" href="' + esc(it.url) + '">' + esc(String(it.product_title).split(' — ')[0]) + '</a>' + (opts && !gift ? '<div class="mp-line__opts">' + opts + '</div>' : '') + (gift ? '' : discs) + controls + '</div>' +
      '<div class="mp-line__price">' + price + '</div></div>';
  }

  function renderCart(cart) {
    $$('[data-mp-cart-count]').forEach(function (el) { var n = cart.items.filter(function (i) { return !(i.properties && i.properties._mp_gift); }).reduce(function (a, i) { return a + i.quantity; }, 0); el.textContent = n; el.setAttribute('data-count', n); });
    $$('[data-mp-cart-body]').forEach(function (body) {
      var scope = body.closest('[data-mp-cart-scope]') || body.parentElement; var foot = scope.querySelector('[data-mp-cart-foot]');
      if (!cart.items.length) {
        body.innerHTML = '<div class="mp-cart__empty">' + (C.icons && C.icons.bed || '') + '<p class="mp-h3">Your cart is empty</p><p class="mp-muted">Every bed comes with a free Big Dog Bundle worth up to ' + esc(C.bundleMax || '') + '.</p><a class="mp-btn" href="' + esc(C.bedUrl || '/') + '">Shop the bed</a></div>';
        if (foot) foot.hidden = true; return;
      }
      if (foot) foot.hidden = false;
      var gifts = [], others = [], beds = 0, bedItem = null;
      cart.items.forEach(function (it) {
        if (it.properties && it.properties._mp_gift) gifts.push(it); else others.push(it);
        if (String(it.product_id) === String(C.bedProductId)) { beds += it.quantity; bedItem = bedItem || it; }
      });
      var giftValue = gifts.reduce(function (a, i) { return a + i.original_line_price; }, 0);
      var html = '';
      if (beds) {
        html += '<div class="mp-cart__progress"><div>' + (beds >= 2 ? '🎉 Free Big Dog Bundle + 2nd bed 50% off unlocked' : '✓ Free Big Dog Bundle unlocked · add a 2nd bed for 50% off') + '</div><div class="mp-cart__bar"><i style="width:' + (beds >= 2 ? 100 : 60) + '%"></i></div></div>';
      } else if (C.bedProductId) {
        html += '<div class="mp-cart__progress"><div>Add a Magic Pillow bed to unlock a free bundle worth up to ' + esc(C.bundleMax || '') + '</div><div class="mp-cart__bar"><i style="width:15%"></i></div></div>';
      }
      html += others.map(function (it) { return lineHTML(it, false); }).join('');
      if (gifts.length) {
        html += '<div class="mp-giftgroup"><div class="mp-giftgroup__head"><span>🎁 Your free Big Dog Bundle</span><span>' + money(giftValue) + ' value</span></div>' + gifts.map(function (it) { return lineHTML(it, true); }).join('') + '</div>';
      }
      if (beds === 1 && bedItem) {
        var half = Math.round(bedItem.original_price / 2);
        html += '<div class="mp-upsell"><div class="mp-upsell__row"><img src="' + esc(img(bedItem.image, 160)) + '" alt=""><div><b>Two big dogs? Add a 2nd bed for ' + money(half) + '</b><span class="mp-small mp-muted">50% off the second bed, applied automatically. Comes with its own free bundle.</span></div></div><button type="button" class="mp-btn mp-btn--block" data-mp-addsecond="' + bedItem.variant_id + '">Add 2nd bed · 50% off</button></div>';
      }
      body.innerHTML = html;
      if (foot) {
        var save = cart.items.reduce(function (a, i) { return a + (i.original_line_price - i.final_line_price); }, 0) + (cart.cart_level_discount_applications || []).reduce(function (a, d) { return a + d.total_allocated_amount; }, 0);
        var sum = foot.querySelector('[data-mp-cart-sum]');
        if (sum) sum.innerHTML = '<div><span>Subtotal</span><span>' + money(cart.original_total_price) + '</span></div>' + (save > 0 ? '<div class="is-save"><span>You save</span><span>−' + money(save) + '</span></div>' : '') + '<div><span>Delivery</span><span>' + esc(C.shippingNote || 'Calculated at checkout') + '</span></div><div class="is-total"><span>Total</span><span>' + money(cart.total_price) + '</span></div>';
        var btn = foot.querySelector('[data-mp-checkout-total]'); if (btn) btn.textContent = money(cart.total_price);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-mp-qty]');
    if (q) { e.preventDefault(); q.disabled = true; Cart.change(q.getAttribute('data-mp-qty'), Number(q.getAttribute('data-q'))).catch(function () { toast('Sorry, that didn\'t work. Please try again.'); }); return; }
    var s = e.target.closest('[data-mp-addsecond]');
    if (s) { e.preventDefault(); s.classList.add('is-loading'); Cart.add([{ id: Number(s.getAttribute('data-mp-addsecond')), quantity: 1 }]).then(function () { toast('2nd bed added at 50% off'); }).catch(function () { toast('Sorry, that didn\'t work.'); }); }
  });
  document.addEventListener('cart:update', function () { Cart.refresh().then(function () { openDrawer('mp-cart'); }); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) Cart.refresh(); });

  /* ---------- product form ---------- */
  function initProduct(sec) {
    var dataEl = sec.querySelector('[data-mp-product-json]'); if (!dataEl) return;
    var P = JSON.parse(dataEl.textContent);
    var form = sec.querySelector('[data-mp-form]');
    var giftRows = $$('[data-mp-gift-row]', sec);
    var state = {};
    function current() {
      var sel = P.options.map(function (o, i) { var c = sec.querySelector('[name="mp-opt-' + i + '"]:checked'); return c ? c.value : null; });
      return P.variants.filter(function (v) { return v.options.every(function (ov, i) { return sel[i] == null || ov === sel[i]; }); })[0];
    }
    function sizeOf(v) { var idx = -1; P.options.forEach(function (n, i) { if (/size/i.test(n)) idx = i; }); return sizeKey(idx > -1 ? v.options[idx] : ''); }
    function update() {
      var v = current(); state.v = v;
      if (!v) return;
      var hid = form && form.querySelector('input[name="id"]'); if (hid) hid.value = v.id;
      $$('[data-mp-price]').forEach(function (el) { el.textContent = money(v.price); });
      $$('[data-mp-compare]').forEach(function (el) { el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; });
      P.options.forEach(function (n, i) { $$('[data-mp-optval="' + i + '"]').forEach(function (el) { el.textContent = String(v.options[i]).split(' (')[0]; }); });
      $$('[data-mp-atc]').forEach(function (b) { b.disabled = !v.available; var l = b.querySelector('[data-mp-atc-label]'); if (l) l.textContent = v.available ? (b.getAttribute('data-label') || 'Add to cart') : 'Sold out'; });
      if (giftRows.length) {
        var sz = sizeOf(v), total = 0;
        giftRows.forEach(function (row) {
          var val = Number(row.getAttribute('data-price-' + sz.toLowerCase()) || row.getAttribute('data-price-' + sz) || row.getAttribute('data-price-l') || 0) * Number(row.getAttribute('data-qty') || 1);
          total += val; var s = row.querySelector('[data-mp-gift-was]'); if (s) s.textContent = money(val);
        });
        $$('[data-mp-gift-total]').forEach(function (el) { el.textContent = money(total); });
        $$('[data-mp-value-total]').forEach(function (el) { el.textContent = money(total + v.price); });
        $$('[data-mp-half]').forEach(function (el) { el.textContent = money(Math.round(v.price / 2)); });
      }
      $$('[data-mp-sticky-opt]').forEach(function (s) { s.value = v.options[Number(s.getAttribute('data-mp-sticky-opt'))]; });
      if (v.featured_media && state.lastMedia !== v.featured_media.id) { var first = state.lastMedia === undefined; state.lastMedia = v.featured_media.id; if (!first || /variant=/.test(location.search)) Gallery.goToMedia(sec, v.featured_media.id); }
      $$('[data-mp-sticky-img]').forEach(function (im) { if (v.featured_image) im.src = v.featured_image.src; });
      if (state.ready) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) { } }
    }
    sec.addEventListener('change', function (e) { if (e.target.name && e.target.name.indexOf('mp-opt-') === 0) update(); });
    $$('[data-mp-sticky-opt]').forEach(function (s) {
      s.addEventListener('change', function () { var i = s.getAttribute('data-mp-sticky-opt'); var r = $$('[name="mp-opt-' + i + '"]', sec).filter(function (x) { return x.value === s.value; })[0]; if (r) { r.checked = true; update(); } });
    });
    function addToCart(btn) {
      var v = state.v || current(); if (!v || !v.available) return;
      btn && btn.classList.add('is-loading');
      Cart.add([{ id: v.id, quantity: 1 }]).then(function () { openDrawer('mp-cart'); })
        .catch(function (err) { toast((err && (err.description || err.message)) || 'Sorry, that didn\'t work.'); })
        .then(function () { btn && btn.classList.remove('is-loading'); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(form.querySelector('[data-mp-atc]')); });
    $$('[data-mp-atc-sticky]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); addToCart(b); }); });
    var sticky = $('[data-mp-sticky]'); var anchor = form && form.querySelector('[data-mp-atc]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (x) { sticky.classList.toggle('is-visible', !x.isIntersecting && x.boundingClientRect.top < 0); }); }, { threshold: 0 });
      io.observe(anchor);
    }
    update(); state.ready = true;
  }

  /* ---------- gallery ---------- */
  var Gallery = {
    init: function (g) {
      var main = g.querySelector('[data-mp-gallery-main]'); if (!main) return;
      var slides = $$('[data-mp-slide]', main), thumbs = $$('[data-mp-thumb]', g), dots = $$('[data-mp-dot]', g);
      function setActive(i) { thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); }); dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); }); var t = thumbs[i]; if (t && t.parentElement) { t.parentElement.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' }); } }
      function go(i) { if (!slides.length) return; i = Math.max(0, Math.min(slides.length - 1, i)); main.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); setActive(i); }
      g._go = go;
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var prev = g.querySelector('[data-mp-prev]'), next = g.querySelector('[data-mp-next]');
      function idx() { return Math.round(main.scrollLeft / main.clientWidth); }
      prev && prev.addEventListener('click', function () { var i = idx() - 1; go(i < 0 ? slides.length - 1 : i); });
      next && next.addEventListener('click', function () { var i = idx() + 1; go(i >= slides.length ? 0 : i); });
      var tm; main.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(function () { setActive(idx()); }, 60); }, { passive: true });
    },
    goToMedia: function (sec, mediaId) {
      var g = sec.querySelector('[data-mp-gallery]'); if (!g || !g._go) return;
      var slides = $$('[data-mp-slide]', g); var i = -1; slides.forEach(function (s, j) { if (s.getAttribute('data-media-id') === String(mediaId)) i = j; });
      if (i > -1) g._go(i);
    }
  };

  /* ---------- size guide ---------- */
  function sgTab(name) {
    $$('[data-sg-tab][role="tab"]').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-sg-tab') === name ? 'true' : 'false'); });
    $$('[data-sg-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-sg-panel') !== name; });
  }
  document.addEventListener('click', function (e) { var t = e.target.closest('[data-sg-tab]'); if (t) sgTab(t.getAttribute('data-sg-tab')); });
  function initCalc(box) {
    var input = box.querySelector('input'), out = box.querySelector('[data-sg-result]'), pick = box.querySelector('[data-sg-pick]'), pressed = box.querySelector('[data-sg-unit][aria-pressed="true"]'), unit = pressed ? pressed.getAttribute('data-sg-unit') : 'in';
    $$('[data-sg-unit]', box).forEach(function (b) { b.addEventListener('click', function () { unit = b.getAttribute('data-sg-unit'); $$('[data-sg-unit]', box).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); input.placeholder = unit === 'cm' ? 'e.g. 95' : 'e.g. 37'; calc(); }); });
    function calc() {
      var n = parseFloat(input.value); if (!n || n <= 0) { out.classList.remove('is-on'); if (pick) pick.hidden = true; return; }
      var cm = unit === 'in' ? n * 2.54 : n, size, why;
      var L = C.sizeLimits || { L: 95, XL: 110 };
      if (cm <= L.L) { size = 'Large'; why = 'Sleeping area 36 × 24 in. Room to curl up or stretch out.'; }
      else if (cm <= L.XL) { size = 'XL'; why = 'Sleeping area 47 × 30 in. Space to sprawl fully.'; }
      else { size = 'XXL'; why = 'Sleeping area 63 × 35 in. Built for the biggest breeds.'; }
      var near = (cm > L.L - 6 && cm <= L.L) || (cm > L.XL - 6 && cm <= L.XL);
      out.innerHTML = '<span class="mp-small">We recommend</span><b>' + size + '</b><span class="mp-small">' + why + (near ? ' You\'re close to the next size up, so if your dog loves to sprawl, size up.' : '') + '</span>';
      out.classList.add('is-on'); out.setAttribute('data-size', size);
      if (pick) { pick.hidden = false; pick.textContent = 'Select ' + size; }
    }
    input.addEventListener('input', calc);
    pick && pick.addEventListener('click', function () {
      var size = out.getAttribute('data-size'); var key = size === 'Large' ? 'L' : size;
      var r = $$('input[name^="mp-opt-"]').filter(function (x) { return /size/i.test((x.closest('fieldset') || {}).textContent || '') && sizeKey(x.value) === key; })[0];
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); closeDrawer(); toast(size + ' selected'); }
      else if (C.bedUrl) location.href = C.bedUrl;
    });
  }

  /* ---------- carousels ---------- */
  function initCarousel(c) {
    var track = c.querySelector('[data-mp-track]'); if (!track) return;
    var step = function () { var card = track.firstElementChild; return card ? card.getBoundingClientRect().width + 14 : 300; };
    var p = c.querySelector('[data-mp-cprev]'), n = c.querySelector('[data-mp-cnext]');
    p && p.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    n && n.addEventListener('click', function () { if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) track.scrollTo({ left: 0, behavior: 'smooth' }); else track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
  }

  /* ---------- announcement ---------- */
  function initAnnounce(a) {
    var msgs = $$('.mp-announce__msg', a), i = 0;
    if (msgs.length > 1) setInterval(function () { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, 4200);
    var t = a.querySelector('[data-mp-countdown]'); if (!t) return;
    var end = Date.parse(t.getAttribute('data-mp-countdown')); if (!end) { t.hidden = true; return; }
    var out = t.querySelector('b');
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { t.hidden = true; return; }
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), ss = s % 60;
      out.textContent = (d ? d + 'd ' : '') + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(ss).padStart(2, '0');
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    var els = $$('.mp-reveal'); if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function boot() {
    $$('[data-mp-announce]').forEach(initAnnounce);
    $$('[data-mp-gallery]').forEach(Gallery.init);
    $$('[data-mp-product]').forEach(initProduct);
    $$('[data-mp-carousel]').forEach(initCarousel);
    $$('[data-sg-calc]').forEach(initCalc);
    initReveal();
    Cart.refresh().catch(function () { });
    if (/[?&]mp_cart=1/.test(location.search)) openDrawer('mp-cart');
    if (location.hash === '#size-guide') openDrawer('mp-size-guide');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.MP = { openDrawer: openDrawer, closeDrawer: closeDrawer, money: money, sgTab: sgTab, cart: Cart };
})();
